import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('Templates', () => {
  describe('Index', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: "共通アンケート_1", description: null, display_web_name: "共通アンケート表示名_1", description_web: null, template_code: 1, m_company_id: 1, share_range_kbn: 1, kbn_name: "新患", part_group_count: 1},
            {id: 2, disable_flg: 0, template_kbn: 20, name: "自社アンケート_1_新患", description: null, display_web_name: "自社アンケート表示名_1_新患", description_web: null, template_code: 1, m_company_id: 1, share_range_kbn: 0, kbn_name: "新患", part_group_count: 2},
            {id: 3, disable_flg: 0, template_kbn: 30, name: "自社アンケート_1_再来", description: null, display_web_name: "自社アンケート表示名_1_再来", description_web: null, template_code: 1, m_company_id: 1, share_range_kbn: 0, kbn_name: "再来", part_group_count: 3},
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      // タイトル
      expect(screen.getByRole("heading", {name: "先確認アンケート一覧"})).toBeInTheDocument();

      // 検索エリア
      expect(screen.getByText('先確認アンケート名')).toBeInTheDocument();
      expect(screen.getByText('アンケート区分')).toBeInTheDocument();
      expect(screen.getByRole("checkbox", {name: "新患用"})).toBeInTheDocument();
      expect(screen.getByRole("checkbox", {name: "再来用"})).toBeInTheDocument();
      expect(screen.getByRole("button", {name: "検索"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('アンケート表示設定')).toBeInTheDocument();
      expect(screen.getByText('アンケート登録')).toBeInTheDocument();

      // 表示エリア
      expect(screen.getByRole("row", {name: "アンケート名 説明 新患／再来 カテゴリ数"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "共通アンケート_1 新患 1 コピー"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "自社アンケート_1_新患 新患 2 コピー"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "自社アンケート_1_再来 再来 3"})).toBeInTheDocument();
    });  
  }); 
});

